import { Injectable } from '@angular/core';
import { JeevesOpenOrdersListTableConfigService } from 'gung-standard-jeeves';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { Order, MetadataService } from 'gung-standard';
import { CultOpenOrdersTableComponent } from '../components/cult-open-orders-table/cult-open-orders-table.component';

class SalesTypeFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'OH_SALESTYPE';
  }

  getOptionIds(item: Order): string[] {
    return [item.extra.oh.salestype];
  }
  getOptionName(key: string): string {
    return this.metadataService.getMetadataValue('xsal', 'salestypedescr', key);
  }
}

class SalesPersonFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'SALESPERSON';
  }

  getOptionIds(item: Order): string[] {
    return [item.extra.oh.saljare];
  }
  getOptionName(key: string): string {
    return this.metadataService.getMetadataValue('salj', 'saljarenamn', key);
  }
}

class CultDeliveryAddressFilter extends SimpleConfigBaseFilter<Order> {
  getName(): string {
    return 'DELIVERY_ADDRESS';
  }

  getOptionIds(item: Order): string[] {
    return [item.extra.oh.ordlevadr1];
  }
  getOptionName(key: string): string {
    return key;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CultOpenOrderConfigService extends JeevesOpenOrdersListTableConfigService {
  getFilters(): ConfigBaseFilter<Order>[] {
    return [...super.getFilters(), new SalesPersonFilter(this.metadataService), new SalesTypeFilter(this.metadataService), new CultDeliveryAddressFilter()];
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CultOpenOrdersTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }
}
